/**
 *
 */
type ObjectType<T> = {
  [key: string]: T;
};

/**
 * Removes keys with empty values (null, undefined, or empty string) from an object
 * @param obj - The object to filter
 * @returns New object containing only keys with non-empty values
 */
export default function removeEmptyKeys<T>(obj: ObjectType<T>): ObjectType<T> {
  return Object.entries(obj).reduce(
    (acc: ObjectType<T>, [key, value]: [string, T]) => {
      if (value !== null && value !== undefined && value !== "") {
        return { ...acc, [key]: value };
      }
      return acc;
    },
    {} as ObjectType<T>
  );
}
